<template>
  <div>
    <el-row style="height: 40px">
      <el-button plain type="primary" size="small" @click="gotoItem" style="margin-right: 20px; margin-left: 20px">返回商品管理</el-button>
      <el-button type="primary" size="small" @click="startSku">同步SKU信息</el-button>

      名称：<el-input v-model="title" size="small" style="width: 120px"></el-input>
      <el-button type="primary" size="small"  @click="getSkuData(-1)" >搜索</el-button>

      预警值：<el-input v-model="hold" size="small" style="width: 80px"></el-input>
      <el-button type="primary" size="small"  @click="openHold" >查看预警</el-button>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border  style="font-size: 12px" :data="skuData" :cell-style="{padding: '0px'}"
                  :header-cell-style="{background:'#F2F6FC',color:'#000'}"  :span-method="objectSpanMethod">
          <el-table-column label="主图" width="80px">
            <template slot-scope="scope" >
              <img width="60px" height="60px" :src="scope.row.picUrl+'_60x60.jpg'" />
            </template>
          </el-table-column>
          <el-table-column  label="商品名称"  width="200px">
            <template slot-scope="scope">
              {{scope.row.title}}<a :href="'https://detail.tmall.com/item.htm?id='+scope.row.numIid"
                                    target="_blank"
                                    class="primary">&#8194;详情</a>
            </template>
          </el-table-column>

          <el-table-column  prop="hh" label="货号" width="100px"></el-table-column>\
          <el-table-column  prop="price" label="单价" width="60px"></el-table-column>
          <el-table-column  prop="skuPropertiesName" label="颜色分类" width="160px"></el-table-column>
          <el-table-column  prop="quantity" label="数量" width="60px"></el-table-column>
          <el-table-column  prop="skuId" label="skuId" width="120px"></el-table-column>
          <el-table-column   label="预警" width="100px">
            <template slot-scope="scope">
              <div><span v-if="scope.row.quantity < hold" style="color: red">预警</span></div>
              <el-button type="text" size="mini" @click="updateWarnSku(scope.row, 1)">恢复</el-button>
              <el-button type="text" size="mini" @click="updateWarnItem(scope.row, 1)">恢复链接</el-button>
            </template>
          </el-table-column>

          <el-table-column  label="简称" width="160px">
            <template slot-scope="scope">
              <el-input type="textarea" :rows="2"  v-model="scope.row.shortName"></el-input>
            </template>
          </el-table-column>
          <el-table-column  label="成本" width="80px">
            <template slot-scope="scope">
              <el-input type="textarea" :rows="1"  v-model="scope.row.cost"></el-input>
            </template>
          </el-table-column>
          <el-table-column  label="" width="60px">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  style="display: inline" @click="updateMemo(scope.$index, scope.row)">更新</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="skuName" lable="本地SKU"  width="120px"></el-table-column>
          <el-table-column width="80px">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  style="display: inline" @click="openOuter(scope.row)">绑定</el-button>
              <el-button type="text" size="mini"  style="display: inline" @click="deleteOuter(scope.row.skuId)">取消</el-button>
            </template>
          </el-table-column>

        </el-table>
      </el-col>
    </el-row>

    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[20, 50, 100, 500, 5000, 20000]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>

    <el-dialog
      title="库存预警" :close-on-click-modal="false"
      :visible.sync="showHold"
      width="850px"
      center>

      <el-row>
        <el-table border  style="font-size: 12px" class="pd" :data="holdData" :header-cell-style="{background:'#F2F6FC',color:'#000'}"
          :cell-style="{padding: '0px'}">
          <el-table-column  label="商品名称"  width="260px">
            <template slot-scope="scope">
              {{scope.row.title}}<a :href="'https://detail.tmall.com/item.htm?id='+scope.row.numIid"
                                    target="_blank"
                                    class="primary">&#8194;详情</a>
            </template>
          </el-table-column>
          <el-table-column  prop="skuPropertiesName" label="颜色分类" width="260px"></el-table-column>
          <el-table-column  prop="quantity" label="数量" width="80px"></el-table-column>

          <el-table-column   label="预警" width="160px">
            <template slot-scope="scope">
              <div><span v-if="scope.row.quantity < hold" style="color: red">预警</span></div>
              <el-button type="text" size="mini" @click="updateWarnSku(scope.row, 0)">忽略</el-button>
              <el-button type="text" size="mini" @click="updateWarnItem(scope.row, 0)">忽略链接</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <div class="block" align="center">
        <span class="demonstration"></span>
        <el-pagination
          @size-change="holdSizeChange"
          @current-change="holdCurrentChange"
          :current-page="pageHold.pageCurrent"
          :page-sizes="[10, 20, 50, 100, 500, 5000, 20000]"
          :page-size="pageHold.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageHold.rowCount">
        </el-pagination>
      </div>
<!--
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showHold=false">确 定</el-button>
      </span>-->
    </el-dialog>

    <el-dialog
      title="本地SKU" :close-on-click-modal="false"
      :visible.sync="showOuter"
      width="850px"
      center>
      <el-row >
        名称：<el-input clearable size="mini" v-model="itemName" style="width: 200px;"></el-input> <el-button type="primary" size="mini" @click="getOuterData" >搜索</el-button>
      </el-row>

      <el-row style="margin-top: 10px;">
        <el-table   :data="outerData" ref="multipleTable" border  style="font-size: 14px; margin-left: 0px" class="exp"
                    :header-cell-style="{ background:'#F2F6FC',color:'#000'}" :default-expand-all="true" :row-style="{height: '0'}" :cell-style="{padding: '2px'}">
          <el-table-column type="expand" width="40">
            <template slot-scope="item">
              <el-table id="sub"  :show-header="false" :data="item.row.skus" ref=""  border style=" font-size: 12px; margin-left: 80px"
                        :header-cell-style="{ background:'#EEEEEE',color:'#000'}"
                        :show-overflow-tooltip="true"  :row-style="{height: '0'}" :cell-style="{padding: '0px'}">
                <el-table-column prop="skuName" label="SKU名称" width="400px"></el-table-column>

                <el-table-column width="120px">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" style="margin-left: 20px" @click="updateOuter(scope.row)" >绑定</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>

          <el-table-column  label="序号" type="index" :index="indexMethod" width="60px" align="center"></el-table-column>
          <el-table-column  prop="title" label="名称"></el-table-column>
        </el-table>
      </el-row>

      <div class="block" align="center">
        <span class="demonstration"></span>
        <el-pagination
          @size-change="outerSizeChange"
          @current-change="outerCurrentChange"
          :current-page="pageOuter.pageCurrent"
          :page-sizes="[10, 20, 50, 100, 500, 5000, 20000]"
          :page-size="pageOuter.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageOuter.rowCount">
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="" @click="showOuter=false">关 闭</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  //import SellerMemo from "./SellerMemo";

    export default {
        name: "Sku",
      //components: {SellerMemo},
      data(){
        return{
          title:'',
          showHold: false,

          hold: 100,
          rspan:1,
          cspan:1,
          skuData:[],
          holdData:[],
          outerData:[],
          pageObject: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 50
          },
          pageHold: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 10
          },
          timer:null,
          funName:'',
          cnName:'',
          //同步完成后提示
          msg:"",
          //外部SKU
          showOuter: false,
          itemName:'',
          pageOuter: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 10
          },
        }
      },
      methods:{
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
          if (this.title.length == 0) {
            if ((columnIndex == 0) || ((columnIndex == 1))) {
              let rowcnt = row.rowCnt;
              let rownum = row.rowNum;

              let lpage = this.pageObject.pageCurrent;
              let lpagesize = this.pageObject.pageSize;

              let rspan = 1;
              let cspan = 1;
              //只要是第0行，不管序号是否为1
              if ((rowIndex == 0) || (rownum == 1)) {
                if (rowcnt - rownum + 1 > lpagesize - rowIndex) {
                  rspan = lpagesize - rowIndex;
                } else {
                  rspan = rowcnt - rownum + 1
                }
                //rspan = 5;
                cspan = 1;
              } else {
                rspan = 0;
                cspan = 0;
              }
              return {
                rowspan: rspan,
                colspan: cspan
              }
            }
          }
        },
        indexMethod(index)
        {
          return index + 1;
        },
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getSkuData(-1);
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getSkuData(-1);
        },
        //改变pageSize
        holdSizeChange: function (val) {
          this.pageHold.pageSize = val;
          this.getSkuData(this.hold);
        },
        //当前页面改变
        holdCurrentChange: function (val) {
          this.pageHold.pageCurrent = val;
          this.getSkuData(this.hold);
        },
        //改变pageSize
        outerSizeChange: function (val) {
          this.pageHold.pageSize = val;
          this.getOuterData();
        },
        //当前页面改变
        outerCurrentChange: function (val) {
          this.pageHold.pageCurrent = val;
          this.getOuterData();
        },
        holdChange(){

        },
        openHold() {
          var numReg = /^[0-9]*$/
          var numRe = new RegExp(numReg)
          if (!numRe.test(this.hold)) {
            this.$message.error('预警值只能输入数字。');
          } else {
            this.showHold = true;
            this.getSkuData(this.hold);
          }
        },
        getSkuData:function (hold) {
          //显示所有时，hold=0，显示预警时为实际值
          let po = this.pageObject;
          if(hold == undefined)
            hold = 0;
          if(hold != -1)
            po = this.pageHold;
          let param={
            nick: storage.get("nick"),
            title:this.title,
            hold: hold,
            pageCurrent: po.pageCurrent,
            rowCount: po.rowCount,
            pageSize: po.pageSize,
          }
          $api.post("/item/getSku", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.state == 1 && dataResult.message == "ok"){
              let pageObject = dataResult.data.pageObject;
              if(hold == -1) {
                this.skuData = dataResult.data.sku;
                this.pageObject.rowCount = pageObject.rowCount;
                this.pageObject.pageSize = pageObject.pageSize;
              }else{
                this.holdData = dataResult.data.sku;
                this.pageHold.rowCount = pageObject.rowCount;
                this.pageHold.pageSize = pageObject.pageSize;
              }

            }else{

              this.$message.error(dataResult);
            }
          })
        },

        //轮询同步状态
        getStatus:function () {
          this.msg='';
          let param={
            nick:storage.get("nick"),
            subNick:storage.get("subnick"),
            funName:this.funName,
            status:"1",
          }
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            if(dataResult.data == "success") {
              this.getSkuData();
              clearTimeout(this.timer);
              this.$message.success("【"+this.cnName +"】数据同步完成。");
              this.msg="【"+this.cnName +"】数据同步完成。";
            }
            else {
              this.timer = setTimeout(this.getStatus, 3000);
              this.msg='running';
              this.$message.warning("【"+this.cnName +"】数据同步中.....");
            }

          })
        },

        startSku:function() {
          this.$confirm('即将开始从淘宝获取数据，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            this.getTbSku();
          })
        },

        getTbSku :function(){
          this.funName="GetSkus";
          this.cnName=" SKU ";
          let param ={
            nick: storage.get("nick"),
            subnick: storage.get("subnick"),
            allItem:'',
          }
          $api.post("/item/getTbSku", param , response =>{
            let dataResult =  response.data;
            if(dataResult.state == 1 && dataResult.message == 'ok'){
              this.timer = setTimeout(this.getStatus, 1000);
            }else{
              this.$message.error(dataResult);
            }
          })
        },
        updateMemo:function (index, row) {
          let param ={
            nick:storage.get("nick"),
            skuId: row.skuId,
            shortName: row.shortName,
            cost:row.cost,
          };
          $api.post("/item/updateSkuShortName", param, response => {
            let dataResult = response.data;

            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.$message({
                type: 'success',
                message: '恭喜，设置简称成本价成功！'
              });
            }else {
              this.$message.error(dataResult);
            }
          })
        },
        gotoItem:function(){
          this.$router.replace({name: 'Item'});
        },
        //SKU列表
        getOuterData(){
          let param={
            nick: storage.get('nick'),
            title: this.itemName,
            pageCurrent: this.pageOuter.pageCurrent,
            rowCount: this.pageOuter.rowCount,
            pageSize: this.pageOuter.pageSize,
          }
          $api.post("/jxc/getSkuList", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.outerData = dataResult.data.sku;
              let pageObject = dataResult.data.pageObject;
              this.pageOuter.rowCount = pageObject.rowCount;
              this.pageOuter.pageSize = pageObject.pageSize;
            }
          })
        },
        openOuter(row){
          this.showOuter = true;
          this.skuId = row.skuId
        },
        updateOuter(row){
          let param = {
            skuId: this.skuId,
            outerSkuId: row.skuId
          }
          $api.post("/item/updateOuterSkuId", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1) {
              this.$message.success("绑定操作已成功！");
              this.getSkuData(-1);
              this.showOuter = false;
            }else{
              this.$message.error(dataResult.data);
            }
          })
        },
        deleteOuter(skuId){
          let param = {
            skuId: skuId,
            outerSkuId: 0
          }
          $api.post("/item/updateOuterSkuId", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1) {
              this.$message.success("取消绑定成功！");
              this.getSkuData(-1);
              this.showOuter = false;
            }else{
              this.$message.error(dataResult.data);
            }
          })
        },
        updateWarnItem(row, warn){
          let param = {
            numIid: row.numIid,
            skuId:'',
            warn: warn,
          }
          $api.post("/item/updateWarn", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1) {
              this.$message.success("操作成功！");
              this.getSkuData(this.hold);
              this.showOuter = false;
            }else{
              this.$message.error(dataResult.data);
            }
          })
        },
        updateWarnSku(row, warn){
          let param = {
            numIid: '',
            skuId: row.skuId,
            warn: warn,
          }
          $api.post("/item/updateWarn", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1) {
              this.$message.success("操作成功！");
              this.getSkuData(this.hold);
              this.showOuter = false;
            }else{
              this.$message.error(dataResult.data);
            }
          })
        }
      },

      mounted(){
        this.getSkuData(-1);
        this.getOuterData();
      }
    }
</script>

<style scoped>

  /* lang="scss" */
  a{
    color: #409EFF;
    text-decoration: none;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .pd /deep/ .el-table td {
    padding: 0px 0px;
  }

</style>



// WEBPACK FOOTER //
// src/page/Sku.vue